import * as React from "react";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import Chip from "@mui/material/Chip";
import ColorLens from "@mui/icons-material/ColorLens";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    width: "100%"
  },
  chips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: theme.spacing(0.5)
  }
}));

const ITEM_HEIGHT = 60;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const SearchableColorCombobox = ({
  colorOptions,
  multiple,
  onSelect,
  placeholder
}) => {
  const classes = useStyles();

  const [inputValue, setInputValue] = useState([]);

  const handleChange = event => {
    const selectedLabels = event.target.value;
    setInputValue(selectedLabels);

    const selectedIds = colorOptions
      .filter(({ label }) => selectedLabels.includes(label))
      .map(({ id }) => id);

    onSelect(selectedIds);
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel>{placeholder}</InputLabel>
      <Select
        multiple={multiple}
        value={inputValue}
        onChange={handleChange}
        input={<Input />}
        renderValue={selected => (
          <div className={classes.chips}>
            {selected.map((value, index) => (
              <Chip key={index} label={value} className={classes.chip} />
            ))}
          </div>
        )}
        MenuProps={MenuProps}
      >
        {colorOptions.map(option => (
          <MenuItem key={option.id} value={option.label}>
            <ColorLens
              style={{
                fill: option.color ? option.color.formatted : "fff",
                marginRight: 8
              }}
            />
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SearchableColorCombobox;
